export const HumanReadableNumber = {
	transform(input: number, withSuffixClass = false) {
		// filter to maximize the character count of a number to 4
		const rest = String(input).length % 3;
		let afterComma = rest; // max
		if (rest === 2 ) {
			afterComma = 1;
		} else if (rest === 1 ) {
			afterComma = 2;
		}
		let str = '';
		if (input < 10000) {
			str = String(input);
		} else if (input < 1000000) {
			str = (input / 1000).toFixed(afterComma) + (withSuffixClass ? '<span class="suffix">K</span>' : 'K');
		} else if (input < 1000000000) {
			str = (input / 1000000).toFixed(afterComma) + (withSuffixClass ? '<span class="suffix">M</span>' : 'M');
		} else {
			str = (input / 1000000000).toFixed(afterComma) + (withSuffixClass ? '<span class="suffix">B</span>' : 'B');
		}

		return str;
	}
};
